import { render, staticRenderFns } from "./AppointmentBookedScreen.vue?vue&type=template&id=1f7458a2"
import script from "./AppointmentBookedScreen.vue?vue&type=script&lang=js"
export * from "./AppointmentBookedScreen.vue?vue&type=script&lang=js"
import style0 from "./AppointmentBookedScreen.vue?vue&type=style&index=0&id=1f7458a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports